import { c as _c } from "react/compiler-runtime";
import { type GetMarketTradersRow, useGetMarketTraders } from '@morfi/backend-sdk-v2/client';
import type { MarketPoolQuoteSnapshot } from '@morfi/market-math';
import { useEffect } from 'react';
import { useLiveListData } from '@/hooks/sdk/use-live-list-data';
import { TRADERS_PROJECTION } from '@/lib/sdk/projections';
import { logger } from '@/lib/telemetry/logger';
import { type MarketTradersSort, type MarketTraderViewModel, toMarketTraderViewModel } from './trader-row';
export function useMarketTraderOwnRank(t0) {
  const $ = _c(24);
  const {
    marketPubkey,
    sortBy,
    sortOrder,
    outcomeIndex,
    outcomeMints,
    rankedWalletAddress,
    currentPoolSnapshot,
    enabled
  } = t0;
  const t1 = rankedWalletAddress ?? "";
  let t2;
  if ($[0] !== outcomeMints) {
    t2 = outcomeMints === undefined ? {} : {
      mints: outcomeMints
    };
    $[0] = outcomeMints;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [...TRADERS_PROJECTION];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== outcomeIndex) {
    t4 = outcomeIndex !== null ? {
      outcomeIndex
    } : {};
    $[3] = outcomeIndex;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== marketPubkey || $[6] !== sortBy || $[7] !== sortOrder || $[8] !== t1 || $[9] !== t2 || $[10] !== t4) {
    t5 = {
      pubkey: marketPubkey,
      sortBy,
      sortOrder,
      walletAddress: t1,
      ...t2,
      fields: t3,
      ...t4
    };
    $[5] = marketPubkey;
    $[6] = sortBy;
    $[7] = sortOrder;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = enabled && rankedWalletAddress !== null;
  let t7;
  if ($[12] !== t6) {
    t7 = {
      resetPaginationOnRefetch: true,
      enabled: t6
    };
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const ownRankQuery = useGetMarketTraders(t5, t7);
  const ownRankRows = useLiveListData(ownRankQuery.queryKey, ownRankQuery.rows, ownRankQuery.entityQueryKey, ownRankQuery.projectEntityRow);
  let t8;
  if ($[14] !== currentPoolSnapshot || $[15] !== ownRankRows[0]) {
    t8 = ownRankRows[0] ? toMarketTraderViewModel(ownRankRows[0], currentPoolSnapshot) : undefined;
    $[14] = currentPoolSnapshot;
    $[15] = ownRankRows[0];
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const ownRankViewModel = t8;
  let t10;
  let t9;
  if ($[17] !== marketPubkey || $[18] !== outcomeIndex || $[19] !== ownRankQuery.isError || $[20] !== sortBy || $[21] !== sortOrder) {
    t9 = () => {
      if (!ownRankQuery.isError) {
        return;
      }
      logger.warn("market.traders.your_rank_fetch_failed", {
        marketPubkey,
        sortBy,
        sortOrder,
        outcomeScoped: outcomeIndex !== null
      });
    };
    t10 = [marketPubkey, outcomeIndex, ownRankQuery.isError, sortBy, sortOrder];
    $[17] = marketPubkey;
    $[18] = outcomeIndex;
    $[19] = ownRankQuery.isError;
    $[20] = sortBy;
    $[21] = sortOrder;
    $[22] = t10;
    $[23] = t9;
  } else {
    t10 = $[22];
    t9 = $[23];
  }
  useEffect(t9, t10);
  return ownRankViewModel;
}